import { ClientDataService, IClientDataDoc } from '../../../services/clientData.service'

export class ProcedureService extends ClientDataService {
  private RESPONSE_UNITS_OPTIONS_DOC = 'tb_nhtsa_responseto'
  private AUTHORIZATION_UNITS_OPTIONS_DOC = 'tb_prprocedure_auth'
  private COMPLICATION_OPTIONS_DOC = 'tb_nhtsa_complications-procedures'
  private ROLE_PERFORMING_OPTIONS_DOC = 'tb_nemsis3_performed_by'
  private NEMSIS_CODES_OPTIONS_DOC = 'tb_nemsis3_snomed'

  async getResponseOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.RESPONSE_UNITS_OPTIONS_DOC)
  }

  async getAuthorizationOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.AUTHORIZATION_UNITS_OPTIONS_DOC)
  }

  async getComplicationsOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.COMPLICATION_OPTIONS_DOC)
  }

  async getRolePerformingOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.ROLE_PERFORMING_OPTIONS_DOC)
  }

  async getNemsisCodeOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.NEMSIS_CODES_OPTIONS_DOC)
  }
}
